export const aboutData = {
  brandIntro: {
    title: '关于 luluca',
    subtitle: '让创作更简单，让灵感更自由',
    description: 'luluca 诞生于2024年，由一群热爱设计与技术的创作者共同打造。我们的使命是降低创作门槛，让每一个人都能轻松表达自己的创意。经过两年的快速发展，luluca 已经成为全球500万用户的创作首选平台。',
    vision: '成为全球最受欢迎的智能创作平台，让每个人都能享受创作的乐趣。',
    mission: '用 AI 技术赋能创意表达，让设计不再有门槛。',
    imageSeq: 'about-brand',
  },
  timeline: [
    { year: '2024 Q1', event: 'luluca 项目正式启动，核心团队组建完成' },
    { year: '2024 Q3', event: '发布 Beta 版本，邀请1000名内测用户' },
    { year: '2025 Q1', event: 'luluca 1.0 正式版上线，用户突破10万' },
    { year: '2025 Q2', event: 'AI 智能配色功能上线，获行业广泛关注' },
    { year: '2025 Q4', event: '全球用户突破200万，完成 A 轮融资' },
    { year: '2026 Q1', event: '推出企业版，支持团队协作与品牌管理' },
    { year: '2026 Q2', event: 'AI 引擎全面升级，全球用户突破500万' },
  ],
  values: [
    {
      title: '用户至上',
      description: '每一个功能设计都始于用户需求，我们持续倾听社区反馈，不断优化产品体验。',
      icon: 'ri-heart-line',
    },
    {
      title: '技术创新',
      description: '我们持续投入 AI 与设计技术的研发，确保 luluca 始终站在行业前沿。',
      icon: 'ri-lightbulb-flash-line',
    },
    {
      title: '开放共享',
      description: '我们相信好的创意应该被更多人看到，致力于构建开放的创作者社区。',
      icon: 'ri-global-line',
    },
    {
      title: '品质追求',
      description: '从产品设计到用户服务，我们追求每一个细节的完美，不妥协于平庸。',
      icon: 'ri-verified-badge-line',
    },
  ],
  testimonials: [
    {
      name: 'TechCrunch',
      role: '国际科技媒体',
      content: 'luluca 是2025年度最值得关注的创意工具之一，其 AI 驱动的设计辅助功能令人印象深刻。',
      logo: 'ri-code-box-line',
    },
    {
      name: '36氪',
      role: '国内知名科技媒体',
      content: 'luluca 重新定义了 AI 创作工具的体验标准，简洁的界面下蕴含着强大的功能。',
      logo: 'ri-news-line',
    },
    {
      name: 'Design Weekly',
      role: '全球设计媒体',
      content: '对于非设计师来说，luluca 是一个革命性的工具，它让专业级设计变得触手可及。',
      logo: 'ri-paint-brush-line',
    },
  ],
  teamMembers: [
    {
      name: '李明远',
      role: '创始人 & CEO',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20entrepreneur%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20modern%20business%20casual%20attire&width=200&height=200&seq=team-ceo&orientation=squarish',
      bio: '连续创业者，前字节跳动设计总监，拥有10年产品设计经验。',
    },
    {
      name: '张雨薇',
      role: '联合创始人 & CTO',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20tech%20leader%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20smart%20confident%20expression%2C%20modern%20professional%20style&width=200&height=200&seq=team-cto&orientation=squarish',
      bio: 'AI 算法专家，前 Google 工程师，斯坦福大学计算机硕士。',
    },
    {
      name: '王子豪',
      role: '设计副总裁',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20male%20creative%20designer%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20artistic%20style%2C%20modern%20casual%20look&width=200&height=200&seq=team-design&orientation=squarish',
      bio: '资深品牌设计师，曾服务于多个国际一线品牌，D&AD 获奖者。',
    },
    {
      name: '陈思琪',
      role: '产品副总裁',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20female%20product%20manager%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20professional%20expression%2C%20modern%20business%20style&width=200&height=200&seq=team-product&orientation=squarish',
      bio: '前腾讯高级产品经理，拥有丰富的 SaaS 产品从0到1的经验。',
    },
  ],
  contact: {
    email: 'hello@luluca.com',
    phone: '400-888-9999',
    address: '北京市朝阳区望京科技园A座18层',
    wechat: 'luluca_official',
  },
};